import React from 'react';
import style from './chart.module.scss';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

const Search = ({ onSearch }) => {
  const handleChange = (e) => {
    onSearch(e.target.value);
  };

  return (
    <div className={style.searchWrapper}>
      <Input
        placeholder="Search..."
        prefix={<SearchOutlined style={{ color: '#00A32E' }} />}
        onChange={handleChange}
        style={{
          background: 'rgba(0, 163, 46, 0.1)',
          border: '1px solid #00A32E',
          borderRadius: '4px',
          color: '#00A32E'
        }}
      />
    </div>
  );
};

export default Search;